<template>
    <v-card v-if='get_current_prize_by_id' :class="{'px-0 py-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}" :width="$vuetify.breakpoint.mdAndUp ? 750 : 'auto'">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('prizes_info_modal')">close</v-icon>
        <v-card-actions :class="{'px-3': $vuetify.breakpoint.xs}">
            <v-layout row justify-space-between align-center>
                <linkRed class="link--icon mr-2" :class="{'flex xs12': $vuetify.breakpoint.xs}"
                         @click.native="prev_prize()"
                >
                    <svg v-svg
                         symbol="arrow-left"
                         size="18"
                         class="mr-2 ml-0"
                         role="presentation"
                    />
                    {{ prev_prize_title }}
                </linkRed>
                <linkRed class="justify-end text-xs-right text-md-left link--icon" :class="{'flex xs12': $vuetify.breakpoint.xs}"
                         @click.native="next_prize()"
                >
                    {{ next_prize_title }}
                    <svg v-svg
                         symbol="arrow-right"
                         size="18"
                         class="ml-2"
                         role="presentation"
                    />
                </linkRed>
            </v-layout>
        </v-card-actions>
        <v-layout column class="mt-4">
            <v-card-title class="display-1 mb-4" :class="{'px-3': $vuetify.breakpoint.xs}">{{ get_current_prize_by_id.title }}</v-card-title>
            <div class="text-xs-center">
                <img :src="get_current_prize_by_id.big_image" alt="">
            </div>
            <v-layout align-center wrap class="my-4"
                      :class="{'px-3': $vuetify.breakpoint.xs}"
            >
                <template v-if="active_tab==0">
                    <buttonRed
                        class="btn_get_prize"
                        :disabled="Number(user.points) < Number(get_current_prize_by_id.price) && !prize_access"
                        :class="{'flex xs12': $vuetify.breakpoint.xs}"
                        @click.native="OPEN_MODAL('get_prize_modal')"
                    >{{$t("Получить приз")}}</buttonRed>
                    <v-layout align-center :class="{'flex xs6 mt-3': $vuetify.breakpoint.xs, 'ml-3': $vuetify.breakpoint.smAndUp}">
                        <div class="grey-text">{{$t("Баллы")}}:</div><div class="headline ml-2">{{ get_current_prize_by_id.price }}</div>
                    </v-layout>
                </template>
                <v-layout v-else column class="pr-4">
                    <div class="grey-text mb-2">{{$t("Промокод")}}</div>
                    <inputBase :value="get_current_prize_by_id.promocode" disabled />
                </v-layout>
                <iconLabel icon_name="idea" class="grey-text " size="15"
                           :no_pointer="true"
                           :class="{'flex xs6 mt-3': $vuetify.breakpoint.xs && active_tab!=1, 'pt-3': active_tab==1, 'flex xs12 mt-0': $vuetify.breakpoint.xs && active_tab==1}"
                >{{ get_current_prize_by_id.theme }}</iconLabel>
            </v-layout>
            <v-flex :class="{'px-3': $vuetify.breakpoint.xs}" v-html="get_current_prize_by_id.full_text" />
        </v-layout>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import iconLabel from '@/components/ui/icons/icon_with_label';
import linkRed from '@/components/ui/links/styled/link_red';
import inputBase from '@/components/ui/inputs/base/input';

import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    iconLabel,
    linkRed,
    inputBase,
  },
  props: {
    prize_access: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('prize_shop', [
      'prizes_info_modal',
      'get_prize_modal',
      'prize_recieved_modal',
      'chosen_prize',
      'get_next_prize',
      'get_prev_prize',
      'next_prize_title',
      'prev_prize_title',
      'get_current_prize_by_id',
      'active_tab',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('prize_shop', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('prize_shop', [
      'next_prize',
      'prev_prize',
    ]),

  },


};
</script>
